module.exports = __webpack_public_path__ + "img/choose-up-stim-disabled.10d0d07b.png";